import * as React from "react"
import { GroupByDateType, GroupByDate } from "../../../components/GroupByDate"
import { BPMChart } from "../../../components/Chart"
import { resultDateTransformer } from "../../../utils/date"
import { BPMAnalyticsAPI } from "../../../api"
import { SeriesTemplate, CommonSeriesSettings, ArgumentAxis, Label, TickInterval, Legend, Series, Point, ValueAxis } from "devextreme-react/chart"
import { GroupByType } from "../../../components/GroupByType"

export const AvailableCreditsChart: React.FunctionComponent<{}> = () => {

    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')
    const [groupBy, setGroupBy] = React.useState<string | undefined>('type')

    const toolbarItems = GroupByType([{ val: 'type', display: 'Type' }], groupBy, (selected) => {
        setGroupBy(selected)
    }).concat(GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    }))

    return (
        <BPMChart title='Total Available Credits' type='spline'
            additionalParams={{ groupBy: groupBy, groupDateBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('credit/available', options, signal))
            }} toolBarItems={() => toolbarItems}>
            {groupBy && <SeriesTemplate
                nameField={groupBy}
            />}
            {!groupBy && <Series name='Credits' />}
            <CommonSeriesSettings
                valueField="count"
                argumentField="date">
                <Point size={0} hoverStyle={{ size: 14, border: { width: 5 }, color: '#000' }}
                    hoverMode='onlyPoint' />
            </CommonSeriesSettings>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined} weeks={groupDateBy == 'week' ? 1 : undefined} months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>
            <ValueAxis type='logarithmic' />
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Credit/charts/AvailableCreditsChart.tsx